"use strict";

define(['app', './ajax-link'], function (app, ajaxLink) {
  return ajaxLink.extend({
    options: {
      callBack: function callBack(data) {
        var url = this.$el.attr('href');
        var urlReplace = '';
        var jsonObject = this.$el.data('params');

        if (data) {
          this.$el.addClass('is-active');
          urlReplace = url.replace('new', 'delete');
          this.$el.attr('href', urlReplace);
          jsonObject.subscribethreadid = data;
        } else {
          this.$el.removeClass('is-active');
          urlReplace = url.replace('delete', 'new');
          this.$el.attr('href', urlReplace);
        }
      }
    },
    events: {
      click: 'ajaxLink'
    }
  });
});